<template>
  <div class="related-categories">
    <div
      v-show="isArrowShow"
      class="swiper-button-prev related-categories--prev"
      slot="button-prev"
    ></div>
    <swiper
      class="swiper"
      ref="categorySlider"
      :options="swiperOption">
      <swiper-slide
        class="swiper-item"
        v-for="(item, i) in sliderData"
        :key="i">
        <a :href="item.link"
           class="related-category"
        >
          <span class="related-category__img-wrap">
            <img :src="item.image" :alt="item.name">
          </span>
          <span class="related-category__title">{{item.name }}</span>
        </a>
      </swiper-slide>
    </swiper>
    <div
      v-show="isArrowShow"
      class="swiper-button-next related-categories--next"
      slot="button-next"
    ></div>
  </div>
</template>
<script>
import 'swiper/css/swiper.css'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import { isTouch } from '@/mixins/isTouchDevice'

export default {
  name: 'CategoryRelatedSlider',
  data () {
    return {
      isArrowShow: false
    }
  },
  components: { SwiperSlide, Swiper },
  props: {
    initialData: {
      type: String
    }
  },
  methods: {
    isShowingArrow () {
      if (window.innerWidth <= 1024) {
        this.isArrowShow = false
        return
      }
      let containerWidth = 0
      document.querySelectorAll('.page-container').forEach(el => {
        if (el.clientWidth > 0) {
          containerWidth = el.clientWidth - 30
        }
      })
      this.isArrowShow = containerWidth / this.sliderData.length <= 155
      this.$refs.categorySlider.$swiper.navigation.update()
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.isShowingArrow()
    })
    window.addEventListener('resize', this.isShowingArrow)
  },
  destroyed () {
    window.removeEventListener('resize', this.isShowingArrow)
  },
  watch: {
    sliderData () {
      this.isShowingArrow()
    }
  },
  computed: {
    sliderData () {
      return JSON.parse(this.initialData)
    },
    swiperOption () {
      return {
        spaceBetween: 5,
        slidesPerView: 'auto',
        centeredSlides: false,
        loop: false,
        navigation: {
          nextEl: '.related-categories--next',
          prevEl: '.related-categories--prev'
        },
        simulateTouch: !isTouch,
        touchStartPreventDefault: false,
        breakpoints: {
          769: {
            spaceBetween: 10
          }
        }
      }
    }
  }
}
</script>

<style lang="sass">
.related-categories
  width: 100%
  max-width: 100%
.related-categories .swiper-wrapper
  align-items: stretch
.related-categories .swiper-container
  padding-bottom: 4px
</style>

<style lang='sass' scoped="">
@import "~swiper/css/swiper.min.css"
@import "../../styles/swiper/swiper"

.category-banner
  .related-categories
    margin: 25px 0 45px
    +mmax($tablet)
      margin: 15px 0 20px

.related-categories
  order: -2
  display: flex
  justify-content: flex-start
  align-items: center
  margin: 0 0 45px
  position: relative
  +mmax($tablet)
    flex-wrap: nowrap
    //overflow-x: auto
    margin: 0 0 20px
  &--prev
    position: static
    transform: none
    margin: 0 25px 0 0
    display: flex
    flex-shrink: 0
  &--next
    position: static
    transform: none
    margin: 0 0 0 25px
    display: flex
    flex-shrink: 0
.swiper-container
  flex-grow: 1
.swiper-slide
  width: 140px
  height: auto
  padding-bottom: 2px
  +mmax($tablet)
    width: 140px
.related-category
  display: flex
  flex-direction: column
  border-radius: 3px
  border: 1px solid #E7E7E7
  background: #F8F8F8
  width: 100%
  flex-shrink: 0
  text-decoration: none
  height: 100%
  &:hover
    .related-category__title
      color: #FF2F00
  &__title
    color: #333
    text-align: center
    font-size: 14px
    font-weight: 400
    line-height: 130%
    transition: color 0.2s
    margin-bottom: 10px
    padding: 0 10px
  &__img-wrap
    width: 90px
    height: 90px
    position: relative
    margin: 0 auto 1px
    font-size: 10px
    img
      position: absolute
      left: 50%
      top: 50%
      max-width: 90%
      max-height: 90%
      transform: translate(-50%, -50%)

</style>
